import Data from '@/public/data/Burgare.json'
import styles from '@/styles/About.module.css'
import Image from 'next/image'
import HomeImage from '../public/img/Home.webp'
// import svTranslations from '../pages/locales/sv/translation.json'
import { useTranslation } from 'react-i18next'

const Hamburgare = () => {
  const grayscaleStyle = {
    filter: 'grayscale(100%)', // Apply grayscale filter
  }
  const { t, i18n } = useTranslation()
  return (
    <section className={styles.cardContainer}>
      <div className={styles.card}>
        <header className={styles.cardHeader}>
          <h2>{t('Hamburger')}</h2>
          <span className={styles.additional}>
            {t('Cheese SEK 5 / Shrimp salad SEK 15 / Bacon SEK 15')}
          </span>
          <h3 className={styles.cardHamInclude}>
            {t(
              'All Hamburgers include lettuce, onion, dressing, ketchup & mustard'
            )}
          </h3>
        </header>
        <main className={styles.cardsContainer}>
          {Data &&
            Data.map((data, id) => (
              <ul className={styles.cardItem} key={id}>
                <li className={styles.imageContainer}>
                  <Image
                    src={data.imageUrl || HomeImage}
                    style={data.imageUrl ? { HomeImage } : grayscaleStyle}
                    className={styles.imageUrl}
                    width={200}
                    height={100}
                    alt={data.alt}
                    aria-label={data.alt || 'Image Not Available'}
                    // priority
                    loading='lazy'
                  />
                  {!data.imageUrl && (
                    <span
                      className={styles.comingSoon}
                      aria-label='Image Not Available'
                    >
                      {
                        // English text
                        t('Image Not Available')
                      }
                    </span>
                  )}
                </li>
                <figcaption className={styles.figCaption}>
                  {t(data.Ingred)}
                  {data.Weight ? (
                    <span className={styles.cardSpan}>{data.Weight}</span>
                  ) : null}
                </figcaption>

                <div className={styles.cardItemWrapper}>
                  {data.Meny ? (
                    <span className={styles.cardSpan}>Meny: {data.Meny}kr</span>
                  ) : null}
                  {data.Regular ? (
                    <span className={styles.cardSpan}>
                      Regular: {data.Regular}kr
                    </span>
                  ) : null}
                </div>
              </ul>
            ))}
        </main>
      </div>
    </section>
  )
}

export default Hamburgare
